import { IInquiryResponse, TInquiryStatus } from '@interfaces/inquiries';
import { IMedicationResponse } from '@interfaces/medications';
import { ISupplementResponse } from '@interfaces/supplements';

export class InquiryResponse {
  createdOn: string;

  id: number;

  inquiryItems: ISupplementResponse[] | IMedicationResponse[];

  inquiryStatusId: TInquiryStatus;

  isSupplementary: boolean;

  medicationInquiriesDto: IMedicationResponse[];

  name: string;

  submittedOn: string;

  supplementInquiriesDto: ISupplementResponse[];

  constructor(dto: IInquiryResponse) {
    const data: IInquiryResponse = dto && typeof dto === 'object' ? dto : ({} as IInquiryResponse);
    this.id = data.id;
    this.name = data.name || '';
    this.inquiryStatusId = data.inquiryStatusId || null;
    this.createdOn = data.createdOn || '';
    this.submittedOn = data.submittedOn || '';
    this.supplementInquiriesDto = Array.isArray(data.supplementInquiriesDto)
      ? data.supplementInquiriesDto
      : [];
    this.medicationInquiriesDto = Array.isArray(data.medicationInquiriesDto)
      ? data.medicationInquiriesDto
      : [];
    this.isSupplementary = Boolean(this.supplementInquiriesDto.length);
    if (this.isSupplementary) {
      this.inquiryItems = this.supplementInquiriesDto;
    } else {
      this.inquiryItems = this.medicationInquiriesDto;
    }
  }
}
